import React, { useState, useEffect } from 'react';
import { getPlant } from '../../services/plantService';
import { getCountry, getState, getCity, getLocation } from '../../services/locationService';
import { getOccasion } from '../../services/occasionService';
import { getRelation } from '../../services/relationService';

function OrderDetailsPopup({ order, onClose }) {
  const [orderDetails, setOrderDetails] = useState({
    plant: null,
    country: null,
    state: null,
    city: null,
    location: null,
    occasion: null,
    relation: null,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOrderDetails = async () => {
      try {
        const [
          plantRes,
          countryRes,
          stateRes,
          cityRes,
          locationRes,
          occasionRes,
          relationRes,
        ] = await Promise.all([
          getPlant(order.plant_id),
          getCountry(order.country_id),
          getState(order.state_id),
          getCity(order.city_id),
          getLocation(order.location_id),
          getOccasion(order.occasion_id),
          getRelation(order.relation_id),
        ]);

        setOrderDetails({
          plant: plantRes.data,
          country: countryRes.data,
          state: stateRes.data,
          city: cityRes.data,
          location: locationRes.data,
          occasion: occasionRes.data,
          relation: relationRes.data,
        });
        setLoading(false);
      } catch (err) {
        console.error(err);
        setError('Failed to fetch order details.');
        setLoading(false);
      }
    };

    fetchOrderDetails();
  }, [order]);

  if (loading) {
    return (
      <div className="fixed inset-0 flex items-center justify-center z-50">
        {/* Overlay */}
        <div className="fixed inset-0 bg-black opacity-60"></div>
        {/* Loading Indicator */}
        <div className="relative bg-gray-800 text-gray-300 p-6 rounded-lg shadow-lg z-50 w-96">
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="fixed inset-0 flex items-center justify-center z-50">
        {/* Overlay */}
        <div className="fixed inset-0 bg-black opacity-60"></div>
        {/* Error Message */}
        <div className="relative bg-gray-800 text-gray-300 p-6 rounded-lg shadow-lg z-50 w-96">
          <p className="text-red-500">{error}</p>
          <button
            onClick={onClose}
            className="mt-4 px-4 py-2 font-bold text-white bg-red-600 rounded hover:bg-red-700"
          >
            Close
          </button>
        </div>
      </div>
    );
  }

  const { plant, country, state, city, location, occasion, relation } = orderDetails;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      {/* Overlay */}
      <div className="fixed inset-0 bg-black opacity-60"></div>

      {/* Popup Content */}
      <div className="relative bg-gray-900 text-gray-200 p-8 rounded-lg shadow-lg z-50 w-full max-w-lg">
        <button
          className="absolute top-2 right-2 text-gray-400 hover:text-gray-100"
          onClick={onClose}
        >
          ✕
        </button>
        <h2 className="mb-6 text-3xl font-bold text-indigo-400">Order Details</h2>
        <div className="space-y-4">
          <div className="flex justify-between">
            <span className="font-semibold text-gray-400">Order ID:</span>
            <span>{order.order_id}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-semibold text-gray-400">Plant Name:</span>
            <span>{plant?.name}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-semibold text-gray-400">Quantity:</span>
            <span>{order.quantity}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-semibold text-gray-400">Total Price:</span>
            <span>${order.total_price}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-semibold text-gray-400">Country:</span>
            <span>{country?.name}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-semibold text-gray-400">State:</span>
            <span>{state?.name}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-semibold text-gray-400">City:</span>
            <span>{city?.name}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-semibold text-gray-400">Location Area:</span>
            <span>{location?.area}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-semibold text-gray-400">Occasion:</span>
            <span>{occasion?.name}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-semibold text-gray-400">Relation:</span>
            <span>{relation?.name}</span>
          </div>
        </div>
        <div className="mt-8 flex justify-end">
          <button
            onClick={onClose}
            className="px-6 py-2 font-bold text-white bg-indigo-600 hover:bg-indigo-700 active:bg-indigo-800 rounded-full"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default OrderDetailsPopup;
